export default {
  functional: true,
  render (h, ctx) {
    const {
      renderFn,
      config,
      context
    } = ctx.props

    if (context) {
      return renderFn.call(context, h, ...config)
    } else {
      return renderFn(h, ...config)
    }

  }
}